import { inject, Injectable } from '@angular/core';
import { MessageService } from 'primeng/api';
import { SeveridadeToast } from '../models/enums/severidade-toast.enum';
import { getErrorMessage } from '../helpers/error-message.helper';

@Injectable({
    providedIn: 'root',
})
export class ToastService {
    messageService = inject(MessageService);

    private mensagemToast: string = '';
    private estadoToast: boolean = false;

    constructor() { }

    setMensagemToast(mensagem: string, severidade: SeveridadeToast) {
        this.mensagemToast = mensagem;
        const isLongError = severidade === SeveridadeToast.Error && mensagem.length > 120;
        this.messageService.add({
            severity: severidade,
            summary: this.getTituloPorSeveridade(severidade),
            detail: this.mensagemToast,
            life: severidade === SeveridadeToast.Error ? (isLongError ? 20000 : 12000) : 3000,
            sticky: isLongError,
            styleClass: isLongError ? 'toast-erro-longo' : undefined
        });
    }

    setMensagemToastErro(error: unknown, fallback?: string) {
        const mensagem = getErrorMessage(error, fallback);
        this.setMensagemToast(mensagem, SeveridadeToast.Error);
    }

    getMensagemToast() {
        return this.mensagemToast;
    }

    getTituloPorSeveridade(severidade: SeveridadeToast): string {
        switch (severidade) {
            case SeveridadeToast.Success:
                return "Sucesso";
            case SeveridadeToast.Error:
                return "Erro";
            case SeveridadeToast.Warn:
                return "Cuidado";
            case SeveridadeToast.Info:
                return "Informação";
        }
        return severidade;
    }

    mostraToast() {
        this.estadoToast = true;
    }

    ocultaToast() {
        this.estadoToast = false;
    }

    toastEhVisivel(): boolean {
        return this.estadoToast;
    }
}
